import React from "react";
import { Box, Button, Paper, Typography, Chip, Grid } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import PersonIcon from "@material-ui/icons/Person";
import AddIcon from "@material-ui/icons/Add";
import useCommonStyles from "./style";

const PatientHeader = ({ patient, onBack }) => {
  const classes = useCommonStyles();

  const timeOfBirth =
    patient?.externalReport?.attributes?.time_of_birth ?? null;

  const { dateOfBirth, formattedTimeOfBirth } = React.useMemo(() => {
    if (!timeOfBirth) {
      return { dateOfBirth: "-", formattedTimeOfBirth: "-" };
    }

    const date = new Date(timeOfBirth);
    return {
      dateOfBirth: date.toLocaleDateString(),
      formattedTimeOfBirth: date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };
  }, [timeOfBirth]);

  const InfoItem = ({ label, value }) => (
    <Grid item xs={12} sm={6} md={3}>
      <Typography className={classes.infoLabel}>{label}</Typography>
      <Typography className={classes.infoValue}>{value || "-"}</Typography>
    </Grid>
  );

  return (
    <Box className={classes.container}>
      <Button
        startIcon={<ArrowBackIosIcon />}
        className={classes.backButton}
        variant="outlined"
        onClick={onBack}
      >
        Back
      </Button>

      {patient && (
        <Paper className={classes.headerPaper}>
          <Box className={classes.headerTop}>
            <Box className={classes.userIconContainer}>
              <Box className={classes.userIcon}>
                <PersonIcon fontSize="small" />
              </Box>
              <Typography className={classes.patientName}>
                {patient.externalReport?.attributes?.name?.trim() ||
                  `${patient.firstName || ""} ${patient.lastName || ""}`.trim()}
              </Typography>
            </Box>

            <Box
              style={{ display: "flex", alignItems: "center", gap: 16 }}
            ></Box>
          </Box>

          {/* General Information Section */}
          <Typography className={classes.sectionTitle}>
            General Information
          </Typography>

          <Grid container spacing={3} className={classes.infoGrid}>
            <InfoItem
              label="Full Name"
              value={
                patient.externalReport?.attributes?.name?.trim() ||
                `${patient.firstName || ""} ${patient.lastName || ""}`.trim()
              }
            />

            <InfoItem
              label="Age"
              value={
                patient.externalReport?.attributes?.age
                  ? `${patient.externalReport.attributes.age} Years`
                  : ""
              }
            />

            <InfoItem
              label="Gender"
              value={patient.externalReport?.attributes?.gender}
            />

            <InfoItem label="Date of Birth" value={dateOfBirth} />

            <InfoItem label="Time of Birth" value={formattedTimeOfBirth} />

            <InfoItem
              label="Birth Place"
              value={patient.externalReport?.attributes?.place_of_birth}
            />

            <InfoItem
              label="Height"
              value={
                patient.externalReport?.attributes?.height_in_cms
                  ? `${patient.externalReport.attributes.height_in_cms} cm`
                  : ""
              }
            />

            <InfoItem
              label="Weight"
              value={
                patient.externalReport?.attributes?.weight_in_kg
                  ? `${patient.externalReport.attributes.weight_in_kg} Kg`
                  : ""
              }
            />

            <InfoItem
              label="Waist Circumference"
              value={
                patient.externalReport?.attributes?.waist_circumference_in_cms
                  ? `${patient.externalReport.attributes.waist_circumference_in_cms} cms`
                  : ""
              }
            />

            <InfoItem label="Phone Number" value={patient.mobile} />

            <InfoItem
              label="Email Address"
              value={patient.externalReport?.attributes?.email}
            />
          </Grid>
        </Paper>
      )}
    </Box>
  );
};

export default PatientHeader;
